// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wr7eWZQUys5sVpuCxClm{min-height:unset;padding:14px 20px 16px}`, "",{"version":3,"sources":["webpack://./src/pages/hubspotWorkflows/ui/hubspotWorkflowView/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA,CACA,sBAAA","sourcesContent":[".containerHeader {\n  min-height: unset;\n  padding: 14px 20px 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"containerHeader": `Wr7eWZQUys5sVpuCxClm`
};
export default ___CSS_LOADER_EXPORT___;
